import { useState, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import Home from "../src/Pages/Home";
import About from "../src/Pages/About";
import LTTPodcast from "../src/Pages/LTTPodcast";
import Resources from "../src/Pages/Resources";
import Library from "../src/Pages/Library";
import Tracks from "../src/Pages/Tracks";
import FAQs from "../src/Pages/FAQs";
import Academies from "../src/Pages/Academies";
import AcademiesOld from "../src/Pages/AcademiesOld";
import LearningCalendar from "../src/Pages/LearningCalendar";
import Programs from "../src/Pages/Programs";
import GenAI from "../src/Pages/GenAI";
import Culture from "../src/Pages/Culture";
import Contact from "../src/Pages/Contact";
import RoleAligned from "../src/Pages/RoleAligned";
import AIAcademy from "../src/Pages/AIAcademy";
import SearchNav from "../src/FunctionComponents/Searchnav";
import AwardContent from "../src/FunctionComponents/AwardFolder/AwardContent";
// import SideNavbar from "../src/FunctionComponents/SideNavbar";
import Reviews from "./FunctionComponents/HomeFolder/Reviews";
// import Floaticons from "./FunctionComponents/HomeFolder/Floaticons";
import Footer from "../src/FunctionComponents/Footer";
import { PageLayout } from "../src/FunctionComponents/PageLayout";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import HomeNavbarmenu from "./FunctionComponents/HomeFolder/HomeNavbarmenu";
import { NavLink, Link } from "react-router-dom";
import AdminFeedback from "./FunctionComponents/PodCastFolder/AdminFeedback";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

import AddFeaturedProgram from "./FunctionComponents/AddEventFolder/AddFeaturedProgram";
import AddUpcomingEvents from "./FunctionComponents/AddEventFolder/AddUpcomingEvents";
import AddRecentUpdates from "./FunctionComponents/AddEventFolder/AddRecentUpdates";
import EventForm from "./FunctionComponents/AddEventFolder/EventForm";
import AdminAnalytics from "./Pages/AdminAnalytics";

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);
  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}

function Pages() {
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  useEffect(() => {
    console.log("0");
    if (activeAccount) {
      console.log("1");
      fetchAccessToken();
      console.log("2");
    }
  }, [activeAccount]);
  const fetchAccessToken = async () => {
    if (!activeAccount)
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    try {
      console.log(activeAccount);
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });
      const bearer = `Bearer ${response.accessToken}`;
      // console.log(bearer);
      localStorage.setItem("token", bearer);
      // console.log("inside try block");
    } catch (error) {
      console.error("Error fetching access token:", error);
      localStorage.clear();
    }
  };
  return (
    <>
      <Router>
        <SearchNav />
        {/* <Floaticons /> */}
        {/* <SideNavbar /> */}
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/Home" exact component={Home} />
          <Route path="/About-LTT" exact component={About} />
          <Route path="/LTT-Podcast" exact component={LTTPodcast} />
          <Route path="/awards" exact component={AwardContent} />
          <Route path="/GenAI-Tools" exact component={GenAI} />
          <Route path="/Resources" exact component={Resources} />
          <Route path="/Academies-Tracks" exact component={Academies} />
          <Route path="/Academies-Tracks-old" exact component={AcademiesOld} />
          <Route path="/Learning-Calendar" exact component={LearningCalendar} />
          <Route path="/Programs-Certifications" exact component={Programs} />
          <Route path="/Library" exact component={Library} />
          <Route path="/Tracks-Markets" exact component={Tracks} />
          <Route path="/FAQs" exact component={FAQs} />
          <Route path="/Feedback" exact component={AdminFeedback} />
          <Route path="/Culture-Insights" exact component={Culture} />
          <Route path="/Contact-Us" exact component={Contact} />
          <Route path="/Admin-Analytics" exact component={AdminAnalytics} />
          <Route
            path="/Role-Aligned-Curriculum"
            exact
            component={RoleAligned}
          />
          <Route path="/AI-Tech" exact component={AIAcademy} />

          <Route path="/AddFeaturedProg" exact component={AddFeaturedProgram} />
          <Route path="/AddUpcomingEvent" exact component={AddUpcomingEvents} />
          <Route path="/AddRecentUpdate" exact component={AddRecentUpdates} />

          <Route exact path="/Reviews">
            <div className="navbar-holder">
              <HomeNavbarmenu />
            </div>
            <Reviews />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}

export default App;
